import { createAction, props } from "@ngrx/store";
import { IAppAppearance } from "../../models/app-appearance.model";

export const loadAppAppearance = createAction(
  "[App Appearance] Load App Appearance",
  props<{ organizationName: string }>()
);

export const loadAppAppearanceSuccess = createAction(
  "[App Appearance] Load App Appearance Success",
  props<{ response: IAppAppearance | null }>()
);

export const loadAppAppearanceFailure = createAction(
  "[App Appearance] Load App Appearance Failure",
  props<{ error: string }>()
);
